import {
  UseVizContainerErrorsAndNotices,
  useVizContainerErrorsAndNotices,
} from '../hooks/useVizContainerErrorsAndNotices';
import { VizContainerNoticesBase, VizContainerNoticesBaseProps } from './VizContainerNoticesBase';

export interface VizContainerNoticesProps
  extends Omit<VizContainerNoticesBaseProps, 'errors' | 'notices'>,
    UseVizContainerErrorsAndNotices {}

/**
 * Optional component used to render notices within `VizContainer.Header`.
 *
 * This is the "enhanced" version of the component that automatically comes with built-in features which require
 * configuration of parent context providers. Instead use `NoticesBase` if you want a much simpler component. Built-in
 * features currently include:
 * - Automatically populating errors and notices from data based on the results from data queries. This feature depends
 *   on being nested within a `DataQueriesProvider`.
 * - Automatically populate notices set via the `useVizPanelNotices` hook.
 * - Processing and normalization of errors and notices for consistent rendering.
 */
export const VizContainerNotices = ({ errors: errorsProp, notices: noticesProp }: VizContainerNoticesProps) => {
  const { errors, notices } = useVizContainerErrorsAndNotices({ errors: errorsProp, notices: noticesProp });

  return <VizContainerNoticesBase errors={errors.errors} notices={notices} />;
};
